import { useEffect, useState } from 'react';

export interface AlternatingMessageOptions {
  interval: number;
  isNotCycling?: boolean;
}

const getNextCyclingIndex = (rotationLength: number, previousIndex: number) => (previousIndex + 1) % rotationLength;
const getNextOrLastIndex = (rotationLength: number, previousIndex: number) =>
  rotationLength - 1 === previousIndex ? previousIndex : previousIndex + 1;

export const useAlternatingMessage = (messages: string[], { interval, isNotCycling }: AlternatingMessageOptions) => {
  const [index, setIndex] = useState(0);
  const [message, setMessage] = useState(messages[0]);

  useEffect(() => {
    const updateMessage = () => {
      const nextIndex = isNotCycling
        ? getNextOrLastIndex(messages.length, index)
        : getNextCyclingIndex(messages.length, index);
      setIndex(nextIndex);
      setMessage(messages[nextIndex]);
    };

    const intervalId = setTimeout(updateMessage, interval);

    return () => clearInterval(intervalId);
  }, [index, interval, isNotCycling, messages]);

  return message;
};
